import { useCallback, useEffect, useState } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import LoadingSpinner from '../../../../../baseComponents/LoaderDecider/LoadingSpinner'
import { ButtonCloseModal, ButtonsModalSmallCentered, ModalFullCentered, ModalSmallCenteredOutside } from '../../../../../baseComponents/Modal'
import { ModalEditComponentProps } from '../../../../../baseComponents/ModalsLayouts/types'
import { CustomSelectWithSearchBar } from '../../../../../forms/CustomSelect'
import { InputHidden } from '../../../../../forms/Input'
import TwinForm from '../../../../../forms/TwinForm'
import { BeforeSubmitHandler } from '../../../../../forms/TwinForm/types'
import twinFetchPost from '../../../../../utils/globals/data'
import withLoading from '../../../../../utils/hoc/withLoading'
import useEditDeleteModal from '../../../../../utils/hooks/useEditDeleteModal'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'
import { AllReduxPayloads } from '../../../../../utils/reducers'
import { PdfTemplatePayload } from '../../../../../utils/reducers/company/pdfTemplates'
import { SpecificPriceRulesPayload } from '../../../../../utils/reducers/products/specificPriceRules'

type ModalPrintProductCertificateProps = ModalEditComponentProps & ReduxModalPrintProductCertificate & {}

const ModalPrintProductCertificate: React.FC<ModalPrintProductCertificateProps> = ({ setOpened, pdfTemplates, specificPriceRules, basicData }) => {
    const { onPreSubmit, openModal } = useModalPrintProductCertificateLogic()
    const { t } = useTwinTranslation()
    return (
        <ModalSmallCenteredOutside opened={true} setOpened={setOpened} onClickOut={false} className='flex_height'>
            <TwinForm beforeSubmitHandler={onPreSubmit} action='/api/app/product/printProductTags' className='flex flex-auto flex-col justify-between gap-10 ' triggerErrors={false} triggerSuccess={false}>
                <CustomSelectWithSearchBar items={pdfTemplates?.productCertificate || {}} label={t('tag', 'Etiqueta')} value={Object.keys(pdfTemplates?.productCertificate || {})?.[0] || ''} name='PdfTemplateId' required={true} />
                <CustomSelectWithSearchBar items={specificPriceRules?.dictionary || {}} label={t('specificPriceRule', 'Tarifa')} value={specificPriceRules?.arrSorted?.[0]?.id || ''} name='SpecificPriceRuleId' required={true} />
                <InputHidden name='ProductId' value={basicData?.id} />
                <ButtonsModalSmallCentered confirmText={t('print', 'Imprimir')} setOpened={() => { }} onCancel={() => setOpened(null)} />
            </TwinForm>
            {openModal?.type === 'edit' ? <ModalPreviewPdfProductCertificate setOpened={() => setOpened(null)} onSubmit={() => { }} allRowData={openModal.allRowData || {}}/> : null}
        </ModalSmallCenteredOutside>
    )
}

const useModalPrintProductCertificateLogic = () => {
    const { openModal, setOpenModal } = useEditDeleteModal()

    const onPreSubmit: BeforeSubmitHandler = useCallback((vals) => {
        setOpenModal({ type: 'edit', allRowData: vals })
        return false
    }, [setOpenModal])

    return { onPreSubmit, openModal }
}

interface ModalPreviewPdfProductCertificateProps extends ModalPreviewPdfProductCertificateLogicProps {}

const ModalPreviewPdfProductCertificate: React.FC<ModalPreviewPdfProductCertificateProps> = ({ setOpened, ...logic }) => {
    const { pdfCode } = useModalPreviewPdfProductCertificateLogic({ setOpened, ...logic})
    return (
        <ModalFullCentered className='flex flex-col modal_preview_pdf' opened={true} setOpened={setOpened}>
            <ButtonCloseModal setOpened={setOpened} />
            {pdfCode ? <object data={pdfCode} type="application/pdf" width="100%" height="100%" aria-label='pdf' className='preview_pdf'></object> : <LoadingSpinner />}
        </ModalFullCentered>
    )
}

interface ModalPreviewPdfProductCertificateLogicProps extends ModalEditComponentProps {}

const useModalPreviewPdfProductCertificateLogic = ({ allRowData }: ModalPreviewPdfProductCertificateLogicProps) => {
    const [pdfCode, setPdfCode] = useState<string | null>(null)
    const getPdfTemplate = useCallback(async () => {
        const result = await twinFetchPost('/api/app/product/getProductCertificatePDF', { ...allRowData })
        if (result) {
            const pdf = await result.blob()
            const fileURL = URL.createObjectURL(pdf)
            setPdfCode(fileURL)
        }
    }, [allRowData, setPdfCode])

    useEffect(() => {
        getPdfTemplate()
    }, [getPdfTemplate])
    return { pdfCode }
}

const modalPrintTagsDispatch = {
    setSpecificPriceRules: (payload: SpecificPriceRulesPayload) => ({ type: 'CHANGE_SPECIFICPRICERULES', payload }),
    setPdfTemplates: (payload: PdfTemplatePayload) => ({ type: 'CHANGE_PDFTEMPLATE', payload }),
}

type ReduxModalPrintProductCertificate = ConnectedProps<typeof modalprintproductcertificateConnect>
const mapModalPrintProductCertificateConnector = (state: AllReduxPayloads) => ({ specificPriceRules: state.specificPriceRules, pdfTemplates: state.pdfTemplates})
const modalprintproductcertificateConnect = connect(mapModalPrintProductCertificateConnector, modalPrintTagsDispatch)

const modalprintproductcertificateConnectLoading = withLoading(ModalPrintProductCertificate, [{ fetchUrl: '/api/app/product/specificPrice/getAllSpecificPriceRules', propName: 'specificPriceRules', setFunctionName: 'setSpecificPriceRules' }, { fetchUrl: '/api/app/config/pdfTemplate/getAllPdfTemplates', propName: 'pdfTemplates', setFunctionName: 'setPdfTemplates' }])
const ModalPrintProductCertificateConnect = modalprintproductcertificateConnect(modalprintproductcertificateConnectLoading)

export default ModalPrintProductCertificateConnect